import { Injectable } from '@angular/core';

/**
 * Sima function-be atrakni
 */
@Injectable({ providedIn: 'root' })
export class Functions {
  public indexOfNumber(inArray: number[], num: number) {
    let result = -1;
    inArray.forEach((obj, index) => {
      if (Number(obj) === num) {
        result = index;
      }
    });
    return result;
  }
}
